// extracted by mini-css-extract-plugin
export default {"points-balance":"styles_points-balance__ViPQe"};